/** @jsx jsx */
// @ts-check
import flags from 'react-flags-select/es/countries';
import { jsx } from 'theme-ui';

function checkCountry(country) {
  return flags[country.toUpperCase()] && country.toLowerCase();
}

/**
 * Displays a flag icon.
 * @param {object} props
 * @param {string} props.country The 2-letter ISO code for the country.
 * @param {string} props.alt The alternate name for the country.
 */
export default function Flag({ country, alt, ...rest }) {
  if (!country) return null;
  const mappedCountry =
    checkCountry(country) || checkCountry(country.slice(0, 2));
  if (!mappedCountry) {
    console.warn(`no flag available for code ${country}`);
  }
  const flag =
    mappedCountry && require(`react-flags-select/flags/${mappedCountry}.svg`);
  return (
    <img
      src={flag}
      alt={alt}
      sx={{ width: 15, verticalAlign: 'middle' }}
      {...rest}
    />
  );
}
